export default __webpack_public_path__ + "27a8595bd99013ffb808f1d5ecc727e0.png";